'use client';import React from 'react';
import { Shield, Lock, Server } from 'lucide-react';
import PageBanner from '../components/PageBanner';

const Security = () => {
    return (
        <>
            <PageBanner
                title="Security at Exibell"
                description="We employ enterprise-grade security measures to ensure your professional data remains safe, secure, and private."
                bgColor="#ECFEFF"
                blobColors={["#22D3EE", "#06B6D4", "#67E8F9"]}
            />

            <div className="container py-20">
                <div className="grid md:grid-cols-3 gap-8 mb-20">
                    <div className="p-8 rounded-2xl bg-white border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                        <div className="w-12 h-12 rounded-lg bg-brand-50 flex items-center justify-center text-brand-600 mb-6">
                            <Shield className="w-6 h-6" />
                        </div>
                        <h3 className="text-xl font-semibold mb-3 text-gray-900">Data Encryption</h3>
                        <p className="text-gray-600">All data is encrypted in transit and at rest using industry-standard AES-256 protocols and TLS 1.3.</p>
                    </div>
                    <div className="p-8 rounded-2xl bg-white border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                        <div className="w-12 h-12 rounded-lg bg-brand-50 flex items-center justify-center text-brand-600 mb-6">
                            <Lock className="w-6 h-6" />
                        </div>
                        <h3 className="text-xl font-semibold mb-3 text-gray-900">Access Control</h3>
                        <p className="text-gray-600">Strict role-based access controls and multi-factor authentication ensure only authorized personnel can access data.</p>
                    </div>
                    <div className="p-8 rounded-2xl bg-white border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                        <div className="w-12 h-12 rounded-lg bg-brand-50 flex items-center justify-center text-brand-600 mb-6">
                            <Server className="w-6 h-6" />
                        </div>
                        <h3 className="text-xl font-semibold mb-3 text-gray-900">Secure Infrastructure</h3>
                        <p className="text-gray-600">Hosted on top-tier cloud providers with 24/7 monitoring, automated backups, and advanced threat detection.</p>
                    </div>
                </div>

                <div className="max-w-3xl mx-auto space-y-12">
                    <section>
                        <h2 className="text-display-xs font-semibold mb-4 text-gray-900">Our Commitment</h2>
                        <p className="text-lg text-gray-600 leading-relaxed">Security is not just a feature; it's a fundamental part of our culture. We are committed to protecting your data and ensuring the reliability of our platform through regular third-party audits and continuous improvement.</p>
                    </section>

                    <section>
                        <h2 className="text-display-xs font-semibold mb-4 text-gray-900">Compliance</h2>
                        <p className="text-lg text-gray-600 leading-relaxed">We continuously monitor and update our practices to comply with relevant data protection regulations including GDPR, CCPA, and industry standards like SOC 2.</p>
                    </section>
                </div>
            </div>
        </>
    );
};

export default Security;
